import { render, staticRenderFns } from "./StokEkstreAlim.vue?vue&type=template&id=252bf607"
import script from "./StokEkstreAlim.vue?vue&type=script&lang=js"
export * from "./StokEkstreAlim.vue?vue&type=script&lang=js"
import style0 from "./StokEkstreAlim.vue?vue&type=style&index=0&id=252bf607&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports